module.exports = __webpack_public_path__ + "static/media/security-image.ec0a26c8.svg";